import React from "react";

export default function ScreenImageTitle(props) {
  const currentSlide = props.currentSlide;
  if (!currentSlide.screenImageTitle) {
    return null;
  }

  const width = window.innerWidth;
  const height = window.innerHeihgt;


  return (
    <div
     id={"full-screen-text"}
      style={{
        backgroundColor: "black",
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "40",
        flexDirection: "column",
        opacity: currentSlide.screenImageTitle ? "1" : "0",
        pointerEvents: "none",
        backgroundColor: "black",
        width: "100vw",
        height: "100vh",
        WebkitTransition: "opacity 2s",
      }}
    >
      {
      props.isMobile ? 
          <img
            src={currentSlide.screenImageTitle}
            height= "100%"
             >
          </img>
      : 
          <img
            src={currentSlide.screenImageTitle}
            height= "100%"
          >
    </img>
    }
    </div>
  );
}
